import { normalizeFields } from "@/forms/helpers";

export const model = normalizeFields({
  phoneNumber: {
    type: "phone",
    label: "add_telephone_number.label",
    value: "",
    required: true,
  },
});
